import React, { useRef } from 'react';

import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import PopupPortal from 'apps/auth/components/common/Popup/PopupPortal';

import DCLeanAccount from './DcLeanAccount';

const DcLeanAccountList = ({ accounts, paymentMethod, formName, icon, badge, actionBanner, modalRef, clickHandler }) => {
    const popupRef = useRef(null);
    let listItems = null;
    if (Array.isArray(accounts) && accounts.length > 0) {
        listItems = (
            <>
                {accounts
                    .filter((account) => account !== null)
                    .map((account) => {
                        return (
                            <DCLeanAccount
                                key={account.code}
                                paymentMethod={paymentMethod}
                                formName={formName}
                                account={account}
                                icon={icon}
                                badge={badge}
                                modalRef={modalRef}
                                clickHandler={clickHandler}
                                actionBanner={actionBanner}
                                popupRef={popupRef}
                            />
                        );
                    })}
            </>
        );
    }
    return (
        <>
            {listItems}
            <PopupNew ref={popupRef} getPopupComponent={(component) => component} as={PopupPortal} />
        </>
    );
};
export default DcLeanAccountList;
